module.exports = __webpack_public_path__ + "static/media/avatar1.5cd08711.jpg";